<template>
    <div class="fee-share-calc">
        <div class="head">
            <div class="row first">
                {{shareName}}总额：
                <el-input style="width: 80px;" size="small" v-model="curShareAmount" type="number" @change="syncShareAmount()"></el-input>
                <span v-show="diffErrMsg" style="margin-left: 20px;">
                    <el-tooltip class="item" effect="dark" placement="top">
                        <span slot="content" style="line-height:30px;">
                            {{diffErrMsg}}
                        </span>
                        <span style="color: #F56C6C; cursor :default;"><i style="color:red;" class="el-icon-info"></i>误差说明</span>
                    </el-tooltip>
                </span>
                <span style="float: right">
                    <el-radio-group v-model="curAspect" @change="syncForAspect">
                        <el-radio label="calc">分摊计算</el-radio>
                        <el-radio label="balns" title="双击分摊明细行 可以 选定 误差承担条目">误差平衡</el-radio>
                        <el-radio label="both" title="双击分摊明细行 可以 选定 误差承担条目">分摊计算+误差平衡</el-radio>
                    </el-radio-group>
                </span>
            </div>
            <div class="row second">
                <span style="color:#AAAAAA" v-show="isCalcMode()">
                    <span style="color:#ff8000">依据 数量 x 参考单价 得出分摊权重，也可</span>
                    <el-checkbox size="mini" style="font-size:12px;" v-model="inputWeight">直接输入分摊权重</el-checkbox>
                </span>
                <span style="float: right">
                    <!--
                    <el-link style="margin-right:32px;" @click="exportResult()">导出分摊结果</el-link>
                    <el-divider direction="vertical"></el-divider>
                    -->
                    <el-button style="margin-right:32px;" @click="doSumFeeAmount" title="从当前 分摊单价*数量 汇总分摊小计和分摊合计，并替换分摊费用总额">分摊反向汇总</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <el-button class="swb-btn swb-btn-outlined" style="margin-left:32px;" @click="execCalcItems()">分摊计算/误差平衡</el-button>
                </span>
            </div>
        </div>
        <el-form class="list" ref="listForm" :model="listForm">
            <el-table :data="listForm.shareItems" class="simple-tbl" style="width:100%;" :row-class-name="getRowClassName" @row-dblclick="handleRowDblClick">
                <el-table-column align="center" label="序号" width="50">
                    <template slot-scope="scope">
                        {{scope.$index + 1}}
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="ukIdTitle" :width="ukIdWidth">
                    <template slot-scope="scope">
                        {{scope.row.ukId}}
                    </template>
                </el-table-column>
                <el-table-column align="left" :label="nameTitle">
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'shareItems[' + scope.$index + '].name'">
                            <span v-if="useForUpdate">{{scope.row.name}}</span>
                            <el-input v-else="" v-model="scope.row.name" size="mini"/>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column align="right" label="数量" width="100">
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'shareItems[' + scope.$index + '].quantity'">
                            <span v-if="useForUpdate">{{scope.row.quantity}}</span>
                            <el-input v-else="" class="number" v-model="scope.row.quantity" type="number" size="mini" @change="syncItemWeight(scope.$index, 'quantity')"/>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column v-if="isCalcMode() && !inputWeight" align="right" label="参考货价" width="100">
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0; color : #ADADAD" :prop="'shareItems[' + scope.$index + '].refPrice'">
                            <span v-if="useForUpdate">{{ formatDecNum(scope.row.refPrice) }}</span>
                            <el-input v-else="" class="number" v-model="scope.row.refPrice" type="number" size="mini" @change="syncItemWeight(scope.$index, 'refPrice')"/>
                        </el-form-item>
                    </template>
                </el-table-column>

                <el-table-column v-if="isCalcMode()" align="right" label="分摊权重" width="100">
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'shareItems[' + scope.$index + '].weight'">
                            <el-input v-if="inputWeight" class="number" v-model="scope.row.weight" type="number" size="mini"/>
                            <span v-else="">{{ formatDecNum(scope.row.weight) }}</span>
                        </el-form-item>
                    </template>
                </el-table-column>

                <el-table-column align="right" label="分摊-单价" width="100">
                    <template slot-scope="scope">
                        <i v-if="scope.row.splitted" style="float:left; margin-top: 4px;color:orangered" @click="showDiffPriceInfo(scope.$index)" class="el-icon-info" title="分摊-单价 有差异 (点击查看) "></i>
                        <span>{{ formatDecNum(scope.row.price) }}</span>
                    </template>
                </el-table-column>

                <el-table-column align="right" label="分摊-小计" width="100">
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'shareItems[' + scope.$index + '].amount'">
                            <el-input class="number" v-model="scope.row.amount" type="number" size="mini"/>
                        </el-form-item>
                    </template>
                </el-table-column>

                <el-table-column align="center" width="64">
                    <template slot="header" slot-scope="scope">
                        <el-link v-if="!useForUpdate" class="el-icon-plus" style="color:darkblue" @click="addShareItem()">追加</el-link>
                    </template>
                    <template slot-scope="scope">
                        <i class="el-icon-close" style="color:#bb4600;cursor:pointer;" title="移除此条目" @click="delShareItem(scope.$index)"></i>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
    </div>
</template>

<script>
    import { Utils, Jqext } from '../../app.base'
    import { Vue, MsgBox, VRowId } from '../../app.vues';

    import { sumFeeAmount, checkShareAmounts } from './funcs';

    let Toast = Jqext.Toast;

    import comnApi from '../../api/comn'

    export default {
        name: 'swb-fee-share-calc',
        desc: '费用分摊计算工具',
        props: {
            //分摊费用名称
            shareName: {
                type: String,
                default: '分摊费用'
            },
            //是否要要用结果进行过更新
            useForUpdate: {//如果用于更新则必须传递 shareAmount 和 shareItems，并且不能新增分摊条目
                type: Boolean,
                default: false
            },
            //分摊总金额
            shareAmount: {
                type: Number,
                default: 0.00
            },
            //所有分摊条目
            shareItems: {
                type: Array,
                default() {
                    return [];
                }
            },
            //标识列显示标题
            ukIdTitle: {
                type: String,
                default: '标识'
            },
            //标识列显示宽度
            ukIdWidth: {
                type: Number,
                default: 60
            },
            //名称列标题
            nameTitle: {
                type: String,
                default: '名称'
            }
        },
        data() {
            return {
                inputWeight: false,
                //
                curAspect: 'calc',
                curShareAmount: 0.00,
                //
                listForm: {
                    shareItems: []
                },
                //
                diffErrMsg: null, //误差错误信息
                //记录是否已经提示过 "双击分摊明细行 可以 选定 误差承担条目"
                bearSelectHintFlag: false
            };
        },
        created() {
            this.theVRowId = VRowId.newOne().name('ukId', 'ukId-');
        },
        mounted() {
            this.initData();
            //自动执行分摊计算
            if(this.useForUpdate) {
                this.execCalcItems();
            }
        },
        methods: {
            formatDecNum(num) {
                return Utils.formatNum(num, '#0.00');
            },
            initShareItem(shareItem) {
                if(shareItem.order == null) {
                    shareItem.order = 0;
                }
                if(shareItem.quantity == null) {
                    shareItem.quantity = 1;
                }
                if(shareItem.weight == null) {
                    if(shareItem.refPrice != null && typeof shareItem.refPrice == 'number') {
                        let refAmount = shareItem.refPrice * shareItem.quantity;
                        shareItem.weight = refAmount.round(2);
                    }
                    else {
                        shareItem.weight = shareItem.quantity;
                    }
                }
                this.theVRowId.setId(shareItem);
            },
            initData() {
                this.curShareAmount = this.shareAmount;
                //
                let shareItems = Utils.merge([], this.shareItems);
                //
                let self = this;
                shareItems.forEach(function (item) {
                    self.initShareItem(item);
                });
                //
                this.$set(this.listForm, 'shareItems', shareItems);
            },
            isCalcMode() {
                return this.curAspect == 'calc' || this.curAspect == 'both';
            },
            isBalnsMode() {
                return this.curAspect == 'balns' || this.curAspect == 'both';
            },
            syncForAspect() {
                if(this.isBalnsMode() && !this.bearSelectHintFlag) {
                    Toast.show('双击分摊明细行 可以 选定 误差承担条目', 5000, 'info');
                    //
                    this.bearSelectHintFlag = true;
                }
            },
            //双击选择误差承担条目
            getRowClassName({row, rowIndex}) {
                let classNames = '';
                if(row.bearFlag == true) {
                    classNames += 'selected';
                }
                return classNames;
            },
            //双击选择/切换误差承担条目
            handleRowDblClick(row, rowIndex) {
                let curUkId = row.ukId;
                let bearFlag = row.bearFlag;
                if(bearFlag == true) {
                    bearFlag = false;
                }
                else {
                    let quantity = Utils.ParseInt(row.quantity);
                    if(quantity == 1) {
                        bearFlag = true;
                    }
                    else {
                        Toast.show('只有数量为 1 的条目才能作为 误差承担 者');
                        return;
                    }
                }
                let shareItem = null;
                if(bearFlag) {
                    let shareItems = shareItems = Utils.merge([], this.listForm.shareItems);
                    for(let i = 0, c = shareItems.length; i < c; i++) {
                        shareItem = shareItems[i];
                        if(shareItem.ukId == curUkId) {
                            shareItem.bearFlag = true;
                        }
                        else {
                            delete shareItem.bearFlag;
                        }
                    }
                    this.$set(this.listForm, 'shareItems', shareItems);
                }
                else {
                    shareItem = row;
                    shareItem.bearFlag = false;
                    this.$set(this.listForm.shareItems, rowIndex, shareItem);
                }
            },
            addShareItem() {
                let shareItems = Utils.merge([], this.listForm.shareItems);
                let shareItem = {
                    quantity: 1,
                    refPrice: 1,
                    weight: 1,
                    name: ''
                };
                this.initShareItem(shareItem);
                shareItems.push(shareItem);
                //
                this.$set(this.listForm, 'shareItems', shareItems);
            },

            delShareItem(index) {
                let shareItems = Utils.merge([], this.listForm.shareItems);
                shareItems.removeAt(index);
                //
                this.$set(this.listForm, 'shareItems', shareItems);
            },

            syncShareAmount() {
                let curShareAmount = Utils.ParseFloat(this.curShareAmount);
                if(curShareAmount != null) {
                    this.curShareAmount = curShareAmount.round(2);
                }
            },

            syncItemWeight(index, srcField) {
                let shareItems = this.listForm.shareItems;
                let shareItem = shareItems[index];
                let quantity = Utils.ParseInt(shareItem.quantity);
                if(!this.inputWeight) {
                    shareItem.quantity = quantity;
                    let refPrice = Utils.ParseFloat(shareItem.refPrice);
                    if(refPrice != null) {
                        refPrice = refPrice.round(2);
                    }
                    shareItem.refPrice = refPrice;
                    if(quantity != null && refPrice != null) {
                        shareItem.weight = (refPrice * quantity).round(2);
                    }
                }
                if(srcField == 'quantity' && quantity !== 1) {
                    shareItem.bearFlag = false;
                    this.$set(this.listForm.shareItems, index, shareItem);
                }
            },
            doSumFeeAmount() {
                let shareItems = this.listForm.shareItems;
                //反向汇总
                this.curShareAmount = sumFeeAmount(shareItems, 2);

                this.$set(this.listForm, 'shareItems', shareItems);
                //重新检查
                this.checkShareAmounts();
            },
            checkShareModel(forResult) {
                forResult = forResult === true;
                //
                if(!forResult) {
                    let curShareAmount = Utils.ParseFloat(this.curShareAmount);
                    if(curShareAmount != null) {
                        this.curShareAmount = curShareAmount.round(2);
                    }
                    if(this.curShareAmount == null || this.curShareAmount < 0) {
                        Toast.show('分摊总金额无效（必须>=0）');
                        return false;
                    }
                }
                //
                let shareItems = this.listForm.shareItems;
                let shareItemCount = shareItems.length;
                if(shareItemCount < 1) {
                    Toast.show('缺少分摊条目（至少要有一条）');
                    return false;
                }
                for(let i = 0; i < shareItemCount; i++) {
                    let shareItem = shareItems[i];
                    let quantity = Utils.ParseInt(shareItem.quantity);
                    shareItem.quantity = quantity;
                    if(shareItem.quantity == null || shareItem.quantity <= 0) {
                        Toast.show('第 ' + (i + 1) + ' 行的 数量 无效（必须>0）');
                        return false;
                    }
                    let weight = Utils.ParseFloat(shareItem.weight);
                    if(weight != null) {
                        weight = weight.round(2);
                    }
                    shareItem.weight = weight;
                    if(shareItem.weight != null && shareItem.weight <= 0) {
                        Toast.show('第 ' + (i + 1) + ' 行的 分摊权重 无效（必须>0）');
                        return false;
                    }
                    if(this.isBalnsMode()) {
                        let amount = Utils.ParseFloat(shareItem.amount);
                        if(amount == null) {
                            if(this.curAspect == 'balns' && !shareItem.bearFlag) {
                                Toast.show('第 ' + (i + 1) + ' 行（为非误差承担条目） 分摊小计 必须填写');
                                return false;
                            }
                        }
                        else {
                            amount = amount.round(2);
                            if(amount < 0) {
                                Toast.show('第 ' + (i + 1) + ' 行 分摊小计 无效（必须>=0）');
                                return false;
                            }
                            shareItem.amount = amount;
                        }
                    }
                    if(forResult) {
                        let price = Utils.ParseFloat(shareItem.price);
                        if(price != null) {
                            price = price.round(2);
                        }
                        shareItem.price = price;
                        if(shareItem.price == null) {
                            Toast.show('第 ' + (i + 1) + ' 行的 分摊-单价 无效（确保已执行过【计算分摊单价】）');
                            return false;
                        }
                    }
                }
                return true;
            },
            //检查 金额分摊 误差
            checkShareAmounts() {
                let shareAmount = this.curShareAmount || 0;
                let shareItems = this.listForm.shareItems || [];
                this.diffErrMsg = checkShareAmounts(shareItems, shareAmount);
                return this.diffErrMsg == null;
            },
            execCalcItems() {
                if(!this.checkShareModel()) {
                    return;
                }
                //
                let feeShareModel = {
                    shareAmount: this.curShareAmount,
                    shareItems: this.listForm.shareItems
                };
                let aspect = this.curAspect;
                //
                let self = this;
                comnApi.calcFeeShareResult(feeShareModel, aspect, function (result) {
                    if(result.success) {
                        //console.log(result.data);
                        let shareItems = result.data;
                        self.$set(self.listForm, 'shareItems', shareItems);
                        //
                        self.checkShareAmounts();
                    }
                    else {
                        MsgBox.failure(result.message);
                    }
                });
            },

            showDiffPriceInfo(index) {
                let shareItems = this.listForm.shareItems;
                let shareItem = shareItems[index];
                let amount = shareItem.amount;
                let price2 = amount - shareItem.price * (shareItem.quantity - 1);
                Toast.show('其中有一个的单价为：' + price2.round(2), 5000, 'warning');
            },

            exportResult() {
                //TODO 导出结果为xls
            },

            getResult() {
                if(!this.checkShareModel(true)) {
                    return null;
                }
                //检查金额是否有误差
                if(!this.checkShareAmounts()) {
                    Toast.show(this.diffErrMsg);
                    return null;
                }
                //
                let shareAmount = Utils.ParseFloat(this.curShareAmount);
                let shareItems = this.listForm.shareItems;
                return {
                    shareAmount: shareAmount.round(2),
                    shareItems: Utils.merge([], shareItems)
                };
            }

        }

    }


</script>

<style>
    .fee-share-calc {
        padding: 2px;
    }

    .fee-share-calc .head .row {
        height: 34px;
        line-height: 34px;
        padding: 0 4px;
    }

    .fee-share-calc .el-table .el-table__body tr.selected > td {
        background-color: #FFEFE5 !important;
        color: #333;
    }

    .fee-share-calc .el-table .el-table__row td .cell .number input.el-input__inner {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/compo/comn/FeeShareCalc.vue